/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/**
 * Generates the theme object for the component from the theme and provided additional information
 * @param  {Object} theme The actual theme object.
 * @return {Object} The final theme object with the overrides and component variables
 */
const generateComponentTheme = theme => {
  var _colors$contrasts, _colors$contrasts2;
  const colors = theme.colors,
    spacing = theme.spacing,
    typography = theme.typography,
    borders = theme.borders;
  const componentVariables = {
    fontSize: typography === null || typography === void 0 ? void 0 : typography.fontSizeMedium,
    fontFamily: typography === null || typography === void 0 ? void 0 : typography.fontFamily,
    fontWeight: typography === null || typography === void 0 ? void 0 : typography.fontWeightNormal,
    color: 'inherit',
    colorInverse: 'inherit',
    itemInlinePadding: spacing === null || spacing === void 0 ? void 0 : spacing.xSmall,
    itemSpacing: spacing === null || spacing === void 0 ? void 0 : spacing.xSmall,
    iconTextGap: spacing === null || spacing === void 0 ? void 0 : spacing.xSmall,
    activeItemFontWeight: typography === null || typography === void 0 ? void 0 : typography.fontWeightBold,
    activeItemIndicatorSpacing: '0.25rem',
    activeIndicatorWidth: borders === null || borders === void 0 ? void 0 : borders.widthMedium,
    activeIndicatorColor: colors === null || colors === void 0 ? void 0 : (_colors$contrasts = colors.contrasts) === null || _colors$contrasts === void 0 ? void 0 : _colors$contrasts.white1010,
    activeIndicatorColorInverse: colors === null || colors === void 0 ? void 0 : (_colors$contrasts2 = colors.contrasts) === null || _colors$contrasts2 === void 0 ? void 0 : _colors$contrasts2.grey125125
  };
  return {
    ...componentVariables
  };
};
export default generateComponentTheme;